export let OrderKeys = {
  adminCount: 'adminCount',
  alphabeticalAscending: 'AZ',
  alphabeticalDescending: 'ZA',
  askDataMode: 'askDataMode',
  authoringEnabled: 'authoringEnabled',
  availability: 'availability',
  averageQueueTime: 'averageQueueTime',
  averageRunTime: 'averageRunTime',
  childProjectCount: 'childProjectCount',
  completedAt: 'completedAt',
  connectionTypeDisplayName: 'connectionTypeDisplayName',
  connectedWorkbooksCount: 'connectedWorkbooksCount',
  contentTypeOrder: 'contentTypeOrder',
  currentLoggedInUserCount: 'currentLoggedInUserCount',
  currentQueueTime: 'currentQueueTime',
  currentRunTime: 'currentRunTime',
  createdAt: 'createdAt',
  creatorName: 'creatorName',
  dataRefreshedTimestamp: 'dataRefreshedTimestamp',
  datasourceCount: 'datasourceCount',
  definition: 'definition', // definition of a remote refresh schedule, for Data Sync
  displayName: 'displayName',
  domainName: 'domainName',
  extractEncryptionMode: 'extractEncryptionMode',
  favoritesTotal: 'favoritesTotal',
  flowFileType: 'flowFileType',
  flowName: 'flowName',
  flowOutputSteps: 'flowOutputSteps',
  flowOutputStepName: 'flowOutputStepName',
  guestAccessEnabled: 'guestAccessEnabled',
  groupCount: 'groupCount',
  hasAlert: 'hasAlert',
  hasExtracts: 'hasExtracts',
  hitsTotal: 'hitsTotal',
  hitsLastTwoWeeksTotal: 'hitsLastTwoWeeksTotal',
  hitsLastOneMonthTotal: 'hitsLastOneMonthTotal',
  hitsLastThreeMonthsTotal: 'hitsLastThreeMonthsTotal',
  hitsLastTwelveMonthsTotal: 'hitsLastTwelveMonthsTotal',
  index: 'index',
  isCertified: 'isCertified',
  lastAccessedAt: 'lastAccessedAt', // used for GetDetailedRecents queries
  lastChecked: 'lastChecked',
  lastRefreshedAt: 'lastRefreshedAt',
  lastRunAt: 'lastRunAt',
  lastSentAt: 'lastSentAt',
  lastSignIn: 'lastSignIn',
  licenseLevel: 'subscriptionLicensingRole',
  jobId: 'jobId',
  jobRequestedTime: 'jobRequestedTime',
  maxSiteRole: 'maxSiteRole',
  metricsEnabled: 'metricsEnabled',
  metricValue: 'metricValue',
  metricConnectedViewName: 'metricConnectedViewName',
  metricUpdated: 'metricUpdated',
  minimumSiteRole: 'minimumSiteRole',
  modifiedBy: 'modifiedBy',
  name: 'name',
  notificationIntervalInMinutes: 'notificationIntervalInMinutes',
  numSheets: 'numSheets',
  numericAscending: 'least',
  numericDescending: 'most',
  ownerName: 'ownerName',
  parallel: 'parallel',
  parentName: 'parentName',
  position: 'position', // used for favorites queries
  priority: 'priority',
  projectName: 'projectName',
  publishedDataSourceName: 'publishedDataSourceName',
  refreshType: 'refreshType', // full or incremental remote refresh, for Data Sync
  relevance: 'relevancy',
  rowsProduced: 'rowsProduced',
  runNextAt: 'runNextAt',
  scheduleName: 'scheduleName',
  scheduleType: 'scheduleType',
  scheduledAction: 'scheduledAction',
  siteAdminsCanAddUsers: 'siteAdminsCanAddUsers',
  siteCount: 'siteCount',
  siteName: 'siteName',
  siteRole: 'siteRole',
  size: 'size',
  sheetImageEnabled: 'sheetImageEnabled',
  startedAt: 'startedAt',
  status: 'status',
  storageQuotaBytes: 'storageQuotaBytes',
  storageQuotaPercentUsed: 'storageQuotaPercentUsed',
  storageUsedBytes: 'storageUsedBytes',
  subject: 'subject',
  subscriptionsTotal: 'subscriptionsTotal',
  targetName: 'targetName',
  taskCount: 'taskCount',
  taskType: 'taskType',
  timeAscending: 'oldest',
  timeDescending: 'newest',
  title: 'title',
  type: 'type',
  updatedAt: 'updatedAt',
  urlName: 'urlName',
  userCount: 'userCount',
  userDisplayName: 'userName', // "displayName" property for the user associated with an item
  username: 'username', // "username" property of a user
  userQuota: 'userQuota',
  versionNumber: 'versionNumber',
  viewCount: 'viewCount',
  workbookCount: 'workbookCount',
  workbookName: 'workbookName'
};
